import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c0c9e12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "counter__lungs" }
const _hoisted_2 = ["title"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "two" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "three" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "four" })
  ])
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  "data-test": "animation-disabled"
}
const _hoisted_6 = { class: "enable_animation_text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      "data-test": "animation-wrapper",
      class: "counter__lungs_wrapper",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleAnimation && _ctx.toggleAnimation(...args))),
      title: 
        _ctx.$t(`ex.breathing.${_ctx.disableAnimation ? 'enable' : 'disable'}_animation`)
      
    }, [
      (!_ctx.disableAnimation)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            "data-test": "animation",
            class: _normalizeClass(["counter__lungs_animated one", {
          animate: !_ctx.disableAnimation,
          [_ctx.counter % 2 ? 'odd' : 'even']: true,
        }]),
            style: _normalizeStyle({ animationDuration: _ctx.animationDuration + 'ms' })
          }, _hoisted_4, 6))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("ex.breathing.enable_animation")), 1)
          ]))
    ], 8, _hoisted_2)
  ]))
}